import {
  AuthContext,
  type AuthContextProps,
  transformUrl,
} from "@/auth/context.tsx";
import { useContext } from "react";
import { resetAnalytics } from "@/analytics";

export { transformUrl };

export const useAuth = (): Exclude<AuthContextProps, "loading" | "unauthenticated"> => {
  const context = useContext(AuthContext);
  if (context === "loading" || context === "unauthenticated") {
    throw new Error("useAuth is called outside of a protected route");
  }
  return context;
};

export const logout = async () => {
  // Production uses the httpOnly cookie. Localhost uses a tab-scoped token
  // because its API cookie is cross-site and unavailable.
  const token = sessionStorage.getItem("token");
  const logoutURL = new URL("/authn/logout", import.meta.env.VITE_API_ENDPOINT);
  let response: Response;
  try {
    response = await fetch(logoutURL, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-Limrun-Client": "console",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
  } catch (error) {
    console.error("Logout request failed", error);
    return;
  }
  if (!response.ok) {
    console.error(`Logout failed: ${response.status}`);
    return;
  }
  const { redirectUrl } = (await response.json()) as { redirectUrl: string };
  sessionStorage.removeItem("token");
  localStorage.removeItem("token");
  resetAnalytics();
  window.location.href = redirectUrl || "/authn/login";
};
